import type { ChangeEvent, ReactNode } from 'preact/compat';
import { forwardRef } from 'preact/compat';

import { Flex } from '@vkontakte/vkui';

import styles from './styles.module.css';

interface Props {
  beforeNode?: ReactNode;
  afterNode?: ReactNode;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (e: KeyboardEvent) => void;
  value: string;
  placeholder: string;
}

const TEXTAREA_MAX_LENGTH = 5000;

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(
  ({ afterNode, beforeNode, value, onChange, onKeyDown, placeholder }, ref) => {
    return (
      <Flex align="end" gap={12} noWrap>
        {beforeNode ? <div className={styles.beforeNode}>{beforeNode}</div> : null}
        <textarea
          name="message"
          className={styles.textarea}
          ref={ref}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          maxLength={TEXTAREA_MAX_LENGTH}
        ></textarea>
        {afterNode ? <div className={styles.afterNode}>{afterNode}</div> : null}
      </Flex>
    );
  }
);
